export default "__VITE_ASSET__gq81ULjq__"